import { baseApi } from "../../../../app/api";
import { store } from "../../../../app/store";
import type { RawOrderResponse } from "../../../../types/api/wcStoreApi/wcStoreApiOrderEndpointsTypes";
import type { TransformedOrder } from "../types/orderApiTypes";
import { transformOrderResponse } from "../helpers/transformOrderResponse";
import { selectLanguageInfo } from "../../../../common/features/language/languageSelectors";

const WC_STORE_API_BASE =
  window.commonVariables?.wcStoreApiBase || "/wp-json/wc/store/v1";

interface GetOrderDetailsParams {
  orderId: number;
  orderKey: string;
  email: string; // Now strictly required
}

export const orderApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrderDetails: builder.query<TransformedOrder, GetOrderDetailsParams>({
      query: ({ orderId, orderKey, email }) => {
        // We can pass the object directly to 'params', RTK Query handles the query string formatting
        return {
          url: `${WC_STORE_API_BASE}/order/${orderId}`,
          params: {
            key: orderKey,
            billing_email: email,
          },
        };
      },
      transformResponse: (response: RawOrderResponse) => {
        const languageInfo = selectLanguageInfo(store.getState());
        return transformOrderResponse(response, languageInfo);
      },
      providesTags: (result) =>
        result ? [{ type: "Order", id: result.id }] : [],
    }),
  }),
});

export const { useGetOrderDetailsQuery } = orderApi;
